import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import videojs from 'video.js';
import { SeriesService } from 'src/app/Core/services/series.service';
import { Location } from '@angular/common';
// import   from 'videojs-seek-buttons'

// import ShareButton from '../sharebutton';
import BigPlayButton from '../bigplaybutton';
import ShareOverlay from '../shareoverlays'
import { UtilService } from 'src/app/Core/services/util.service';
declare var $: any;
// videojs.registerComponent('ShareButton', ShareButton);
videojs.registerComponent('BigPlayButton', BigPlayButton);
// videojs.registerComponent('ShareOverlay', ShareOverlay);

@Component({
  selector: 'app-seriesplayer',
  templateUrl: './seriesplayer.component.html',
  styleUrls: ['./seriesplayer.component.css']
})


export class SeriesplayerComponent implements OnInit, OnDestroy {
  id: string;
  id2: string;
  seriesinfo: any;
  stream_Url: any;
  currentUrl: any;
  videoUrl: any;
  isVideoOpened: boolean;
  seriesId: any;
  remainingTimeThreshold = 10
  videoTitle: any
  titles: string
  isPlaying: boolean = false;
  currentEpisodeId: any;
  player: any;
  titleSpan: any
  playerElement: any
  titleBarContainer: any
  currentIndex: any
  showModal: boolean = false;
  modalTitle: string = 'Error';
  OToken:any;
  url:any;
  //custom player
  videoWrapper: HTMLElement;
  video: HTMLVideoElement;
  videoControls: HTMLElement;
  epgImage: string =''
  videoDuration: string = '00:00';
  totalVideoDuration:string = '00:00';
  remainingAlert :string ;
  fullscreenControl: HTMLElement;
  playControl: HTMLElement;
  stopControl: HTMLElement;
  replayControl: HTMLElement;
  rewindControl: HTMLElement;
  forwardControl: HTMLElement;
  volumeControl: HTMLElement;
  volumeSlider: HTMLInputElement;
  progressBar: HTMLElement;
  captionControl: HTMLElement;
  isFullScreen:boolean=false;
  hideControlsTimeout: any;
  showSeasonBar:boolean =false;
  showNextSeason:boolean = false;
  private controlsTimeout: any;
  seriesTimeEnds:any = 0;
  nextPlayTimeinterval:any;
  seriesFrom:any;
  toggleEpgClosed:boolean = true;
  constructor(private elRef:ElementRef,private router: Router,
    private route: ActivatedRoute, private seriesService: SeriesService, private location: Location,private utilService:UtilService) { 
    this.OToken = this.utilService.getOneStreamToken();

    }
    
    ngOnInit(): void {
      // const navigation = this.router.getCurrentNavigation();
      // const state = navigation?.extras.state as { link?: string };
      // console.log(state);
      const state = window.history.state as { link: string; container_extension: string };
      
      this.id2 = state?.container_extension;
      this.url = state?.link;
      console.log(state,'urls',this.id2,this.url);
      // if(){

      // }
      this.id = this.route.snapshot.params['id'];
      // this.id2 = this.route.snapshot.params['id2'];
      // this.videoTitle = this.route.snapshot.params['title']
      if (this.id && this.id2 && !this.OToken) {
        console.log(this.id, this.id2, 'ids');
        this.stream_Url = this.seriesService.getStreamSeriesUrl(this.id, this.id2);
        this.playSeries();
      } else if(this.OToken){
        this.stream_Url = this.url;
        this.playSeries();
      }
      this.seriesId = localStorage.getItem('seriesData')
      this.seriesId = JSON.parse(this.seriesId)
      console.log(this.seriesId, 'series ids....');
      this.getSeriesData()
        // custom player 
      this.videoWrapper = document.querySelector('.video-container') as HTMLElement;
      this.video = document.querySelector('.video-container__video') as HTMLVideoElement;
      this.videoControls = document.querySelector('.video-container__controls') as HTMLElement;
      this.fullscreenControl = document.querySelector('.control--fullscreen') as HTMLElement;
      this.playControl = document.querySelector('.control--play') as HTMLElement;
      // this.stopControl = document.querySelector('.control--stop') as HTMLElement;
      this.replayControl = document.querySelector('.control--replay') as HTMLElement;
      this.rewindControl = document.querySelector('.control--backward') as HTMLElement;
      this.forwardControl = document.querySelector('.control--forward') as HTMLElement;
      this.volumeControl = document.querySelector('.control--volume__button') as HTMLElement;
      this.volumeSlider = document.querySelector('.control--volume__slider') as HTMLInputElement;
      this.progressBar = document.querySelector('.progress') as HTMLElement;
      this.captionControl = document.querySelector('.control--caption') as HTMLElement;
      this.addEventListeners();
    }
     @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'f' || event.key === 'F') {
      this.toggleFullscreen();
    }
  }
    //   startTimerNext(){
    //   let totalSeconds = 15;
    //   this.nextPlayTimeinterval = setInterval(() => {
    //     if (totalSeconds > 0) {
    //       totalSeconds--;
    //      this.seriesTimeEnds= this.formatTime(totalSeconds);
    //     } else {
    //       clearInterval(this.nextPlayTimeinterval);
    //       this.toggleNextPlaySeason()
    //     }
  
    //   }, 1000);
    // }
    addEventListeners() {
    this.videoWrapper.addEventListener('mouseover', () => this.playerControlsVisibility(true));
    this.videoWrapper.addEventListener('mouseout', () => this.playerControlsVisibility(false));
    this.videoWrapper.addEventListener('mousemove', () => this.playerControlsVisibility(true));
    this.video.addEventListener('loadedmetadata', () => this.updateVideoInfo());
    this.playControl.addEventListener('click', e => this.togglePlayPause(e));
    // this.stopControl.addEventListener('click', () => this.stopVideo());
    this.replayControl.addEventListener('click', () => this.replayVideo());
    this.rewindControl.addEventListener('click', () => this.rewindVideo());
    this.forwardControl.addEventListener('click', () => this.forwardVideo());
    this.volumeControl.addEventListener('click', e => this.toggleMute(e));
    this.volumeSlider.addEventListener('input', () => this.changeVolume());
    this.video.addEventListener('timeupdate', () => this.updateProgress());
    this.progressBar.addEventListener('click', e => this.seek(e));
    this.fullscreenControl.addEventListener('click', () => this.toggleFullscreen());
    // this.captionControl.addEventListener('click', () => this.toggleCaptions());
    document.addEventListener('webkitfullscreenchange', () => this.onFullscreenChange());
    document.addEventListener('mozfullscreenchange', () => this.onFullscreenChange());
    document.addEventListener('fullscreenchange', () => this.onFullscreenChange());
  }
    updateVideoInfo() {
    this.videoTitle =  this.titles;
    this.updateRemainingTime();
    this.video.addEventListener('timeupdate', () => this.updateRemainingTime());
   }

    formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
  
    if (hours > 0) {
    return `${this.padTime(hours)}:${this.padTime(minutes)}:${this.padTime(secs)}`;
    } else {
    return `${this.padTime(minutes)}:${this.padTime(secs)}`;
    }
    }

    private updateRemainingTime(): void {
    const remainingTime =  this.video.currentTime;
    const timeDeffrence = this.video.duration - this.video.currentTime
    this.remainingAlert = this.formatTime(timeDeffrence)
    this.videoDuration = this.formatTime(remainingTime);
    this.totalVideoDuration = this.formatTime(this.video.duration);

    }

    private padTime(time: number): string {
    return time.toString().padStart(2, '0');
    }

  togglePlayPause(e: Event) {
    const target = e.currentTarget as HTMLElement;
    if (target.classList.contains('paused')) {
      this.video.play();
    } else {
      this.video.pause();
    }
    target.classList.toggle('paused');
  }

  // stopVideo() {
  //   this.video.pause();
  //   this.video.currentTime = 0;
  //   this.playControl.classList.add('paused');
  // }

  replayVideo() {
    this.video.currentTime = 0;
    this.playControl.classList.remove('paused');
    this.video.play();
  }
  

  rewindVideo() {
    this.video.currentTime -= 10;
  }

  forwardVideo() {
    this.video.currentTime += 10;
  }
  changeVolume(): void {
    const volume = parseFloat(this.volumeSlider.value);
    
    this.video.volume = volume;
    const parent = this.volumeSlider.parentElement as HTMLElement;
    if (volume > 0) {
    parent.classList.remove('muted');
    } else {
    parent.classList.add('muted');
    }
    }

  toggleMute(e: Event) {
    const target = (e.currentTarget as HTMLElement).parentNode as HTMLElement;
    target.classList.toggle('muted');
    if (target.classList.contains('muted')) {
      this.volumeSlider.value = '0';
      this.video.volume = 0;
    } else {
      this.volumeSlider.value = '1';
      this.video.volume = 1;
    }
  }
  toggleCaptions() {
    const track = this.video.textTracks[0];
    if (track.mode === 'showing') {
      track.mode = 'hidden';
    } else {
      track.mode = 'showing';
    }
  }
 toggleFullscreen() {
    if (!document.fullscreenElement) {
        // Define fullscreen options
        const fullscreenOptions: FullscreenOptions = { navigationUI: "show" };

        // Enter fullscreen mode with options
        this.videoWrapper.requestFullscreen(fullscreenOptions)
            .catch(err => {
                console.error(`Error attempting to enable fullscreen mode: ${err.message}`);
            });
        console.log(fullscreenOptions);
        // this.utilService.showErrorSuccess('Fullscreen')
        this.setEpgImagePosition('absolute', '-54rem');
    } else {
        // Exit fullscreen mode
        document.exitFullscreen()
            .catch(err => {
                console.error(`Error attempting to exit fullscreen mode: ${err.message}`);
            });

        this.setEpgImagePosition('absolute', '-46rem'); // Reset position when exiting fullscreen
    }
    this.applyFullscreenStyles();

}
applyFullscreenStyles() {
  const toastElement = document.querySelector('.custom-toast') as HTMLElement; // Cast to HTMLElement
  if (toastElement) {
    toastElement.style.zIndex = '10000';  // Ensure high z-index
  }
}
/* Close fullscreen */
closeFullscreen() {
  if ((document as Document).exitFullscreen) {
  (document as Document).exitFullscreen();
  this.isFullScreen = false;
    this.openControlFullscreen();
  } else if ((document as Document).exitFullscreen) {
  /* Safari */
  (document as Document).exitFullscreen();
  this.isFullScreen = false;
  this.openControlFullscreen();
  }
  }

  closeControlFullscreen(){
  //  setTimeout(() => {
  //   this.videoControls.style.display = this.isFullScreen ? 'none' : 'inline'
  //  }, 5000);
  }
  openControlFullscreen(){
    // setTimeout(() => {
    //   this.videoControls.style.display = this.isFullScreen ? 'none' : 'inline'
    //  }, 1000);
  }

onFullscreenChange() {
  const isFullscreen = !!document.fullscreenElement;
  const expandIcon = this.fullscreenControl.querySelector('img.fa-expand') as HTMLElement;
  const compressIcon = this.fullscreenControl.querySelector('i.fa-compress') as HTMLElement;
  
  if (expandIcon && compressIcon) {
    expandIcon.style.display = isFullscreen ? 'none' : 'inline';
    compressIcon.style.display = isFullscreen ? 'inline' : 'none';
  }

  if (isFullscreen) {
    this.hideControlsAfterTimeout();
    this.setEpgImagePosition('absolute', '-55rem');

  } else {
    this.showControls();
    this.setEpgImagePosition('absolute', '-46rem');

  }
}
setEpgImagePosition(position: string, top: string) {
  const epgImage = document.querySelector('.epg-image') as HTMLElement;
  if (epgImage) {
    epgImage.style.position = position;
    epgImage.style.top = top;
  }
}

showControls() {
  this.videoControls.classList.add('visible');
  clearTimeout(this.hideControlsTimeout);
}

hideControls() {
  this.videoControls.classList.remove('visible');
}

hideControlsAfterTimeout() {
  this.showControls();
  this.hideControlsTimeout = setTimeout(() => {
    if (document.fullscreenElement) {
      this.hideControls();
    }
  }, 3000);
}


  updateProgress() {
    const progress = (100 / this.video.duration) * this.video.currentTime;
    document.querySelector('.progress__current').setAttribute('style', `width:${progress}%`);
  }

  seek(e: MouseEvent) {
    const offsetX = e.offsetX;
    const goToTime = (offsetX / this.progressBar.offsetWidth) * this.video.duration;
    this.video.currentTime = goToTime;
  }


  playerControlsVisibility(visible: boolean) {
    if (visible) {
      this.videoControls.classList.add('visible');
      this.startControlsHideTimer();
    } else {
      this.videoControls.classList.remove('visible');
    }
   }
   startControlsHideTimer() {
    this.clearControlsHideTimer(); // Ensure no previous timer is running
    this.controlsTimeout = setTimeout(() => {
      this.videoControls.classList.remove('visible');
    }, 3000); // 10 seconds
  }
  
  clearControlsHideTimer() {
    if (this.controlsTimeout) {
      clearTimeout(this.controlsTimeout);
      this.controlsTimeout = null;
    }
  }
    
  onClickplayNextEpisode(){
      this.video.pause();
      this.playControl.classList.add('paused');
      this.titles = this.titles
      this.currentEpisodeId = this.id;
      let nextEpisodeId = null;
      let nextExtension = null;
      this.currentIndex = this.currentIndex + 1;
      // reset interval or close nextplay 
      // clearInterval(this.nextPlayTimeinterval);
      // this.toggleNextPlaySeason()
      console.log(this.currentEpisodeId, 'currnt id', this.seriesId.length, 'index', this.currentIndex);
      for (var i = this.currentIndex; i <= this.seriesId.length; i++) {
        this.seriesId.forEach((element, index) => {
          if (this.currentIndex === index) {
            nextEpisodeId = element.id;
            nextExtension = element.container_extension;
            this.titles = element.title
            console.log(this.titles, 'titles');
          }
        });
        if (nextEpisodeId == null && nextExtension == null) {
          // this.player.dispose()
          this.location.back();
          // this.router.navigate([`/series/watch/${this.id}`])
        }
        // this.currentIndex++;
        console.log(nextEpisodeId, nextExtension, this.currentIndex, this.titles, 'id extensions...');
        break
      }
        if (nextEpisodeId !== null) {
        // const nextEpisode = this.seriesId.find((episode: any) => episode.id === nextEpisodeId);
        this.stream_Url = this.seriesService.getStreamSeriesUrl(nextEpisodeId, nextExtension);
        videojs("series-player", {
         }).src([{ type: "video/mp4", src: this.stream_Url }]);
         
        }
        setTimeout(() => {
          
          if(this.totalVideoDuration > '0'){
            this.playAfter()
          }
        }, 1000);
        
        // this.startTimerNext()
    }
     playAfter(){
      this.video.play();
      this.playControl.classList.remove('paused');
    }

    ngAfterViewInit(): void {
      require('videojs-seek-buttons');
      //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
      //Add 'implements AfterViewInit' to the class.
      // this.playSeries();
      // this.addKeyPressEvent();
      // this.getSeriesData();
      
    }
    
    getSeriesData() {
      this.seriesId.forEach((element, index) => {
        if (element.id == this.id) {
          this.titles = element.title
          this.currentIndex = index;
        // this.playNextEpisode()
        
      }
      
    });
    
  }
  playNextEpisode() {
    this.currentEpisodeId = this.id;
    let nextEpisodeId = null;
    let nextExtension = null;
    this.currentIndex = this.currentIndex + 1;

    console.log(this.currentEpisodeId, 'currnt id', this.seriesId.length, 'index', this.currentIndex);
    for (var i = this.currentIndex; i <= this.seriesId.length; i++) {
      this.seriesId.forEach((element, index) => {
        if (this.currentIndex === index) {
          nextEpisodeId = element.id;
          nextExtension = element.container_extension;
          this.titles = element.title
          console.log(this.titles, 'titles');
          if(this.OToken){
            const link = element.links.mp4 ? element.links.mp4 : element.links.mkv;
            this.url = link;
          }
        }
      });
      if (nextEpisodeId == null && nextExtension == null) {
        // this.player.dispose()
        this.location.back();
        // this.router.navigate([`/series/watch/${this.id}`])
      }
      // this.currentIndex++;
      console.log(nextEpisodeId, nextExtension, this.currentIndex, this.titles, 'id extensions...');
      break
    }
    
    
    // for (let i = this.currentIndex; i < this.seriesId.length; i++) {
      //   console.log(this.seriesId.length,'looping');
      
      //   if (this.seriesId[i].id > this.currentEpisodeId) {
        //     console.log(this.seriesId[i],'iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii');
        //     this.currentEpisodeId = this.currentEpisodeId + 1;
        //     nextEpisodeId = this.seriesId[i].id++;
        //     nextExtension = this.seriesId[i].container_extension;
        //     this.videoTitle = this.seriesId[i].title
        //     console.log(nextEpisodeId,nextExtension,this.videoTitle,'next id or extension');
        
        //     break;
        //   }else{
          //     nextEpisodeId = this.seriesId[i].id;
          //     nextExtension = this.seriesId[i].container_extension;
          //   }
          // }
          
          // If next episode ID is found, play it
          if (nextEpisodeId !== null) {
        // const nextEpisode = this.seriesId.find((episode: any) => episode.id === nextEpisodeId);
        if(this.OToken){
          this.stream_Url= this.url;
        }else{
          

          this.stream_Url = this.seriesService.getStreamSeriesUrl(nextEpisodeId, nextExtension);
          this.titles = this.titles
          console.log(this.stream_Url, 'url', this.titles);
        }
      
      videojs("series-player", {
        controls: true, // enable controls
        autoplay: true, // enable autoplay
        preload: "auto", // preload video
        muted: false
      }).src([{ type: "video/mp4", src: this.stream_Url }]);
    }
  }

  
  playSeries_() {
    
    setTimeout(() => {
    
          console.log(this.stream_Url, 'url');
          videojs("series-player", {
            
            autoplay: false, // enable autoplay
            preload: "auto", // preload videoShareOverlay
            muted: false
      }).src([
        { type: "video/mp4", src: this.stream_Url }
      ]);
      
      this.player = videojs('series-player');
      
      

      this.player.on('ended', () => {
        this.playNextEpisode()
        console.log("next play");
        
     
      });


      this.player.on('error', () => {
        this.player.removeChild('BigPlayButton')

        this.showModal = true;
        this.modalTitle = 'Error - Video Paused';
        setTimeout(() => {
          // this.playNextEpisode()
        }, 1000);
      })


    }, 1000
  );

  }

   playSeries() {
      setTimeout(() => {
        videojs("series-player", {
          autoplay:true,
          preload:"auto",         
        }).src([
          { type: "video/mp4", src: this.stream_Url }
        ]);
        this.video.play();
        this.playControl.classList.remove('paused');
      this.player = videojs('series-player');
      this.player.on('ended',()=>{
      this.playNextEpisode()
      })
     
    }, 1000
  );

  }

  closePlayNext() {
    this.showModal = false
    this.playNextEpisode()
  }
  closeModal() {
    this.showModal = false
  }

  // addTitleBar() {
  //   this.removeTitleBar();
  //   this.playerElement = this.player.el();
    
  //   this.titleBarContainer = document.createElement('div');
  //   this.titleBarContainer.classList.add('videojs-title-bar'); 
   
  //   this.titleSpan = document.createElement('span');
  //   this.titleSpan.style.fontSize = '20px';
  //   this.titleSpan.style.position = 'absolute';
  //   this.titleSpan.style.top = '3rem';
  //   this.titleSpan.style.left = '0';
  //   this.titleSpan.style.width = '100%';
  //   this.titleSpan.style.zIndex = '99';
  //   this.titleSpan.style.display = 'flex';
  //   this.titleSpan.style.height = '50px';
  //   this.titleSpan.style.alignItems = 'center';
  //   this.titleSpan.style.justifyContent = 'center';
  //   this.titleSpan.style.background = 'rgb(12 0 0 / 10%)';
  //   this.titleSpan.style.userSelect = 'none';
  //   this.titleSpan.style.display = '{ isPlaying ? "none" : "block"}'
  //   this.titleSpan.textContent = this.titles;
  //   this.titleBarContainer.appendChild(this.titleSpan);
  //   this.playerElement.insertBefore(this.titleBarContainer, this.playerElement.element);
  //   console.log(this.titleSpan, this.titleBarContainer, this.playerElement.firstChild, 'titles');

  //   this.disableTitle()
  // }

  addTitleBar() {

  this.removeTitleBar();
  this.playerElement = this.player.el();

  this.titleBarContainer = document.createElement('div');
  this.titleBarContainer.classList.add('videojs-title-bar');

  this.titleSpan = document.createElement('span');
  this.titleSpan.style.fontSize = '20px';
    this.titleSpan.style.position = 'absolute';
    this.titleSpan.style.top = '3rem';
    this.titleSpan.style.left = '0';
    this.titleSpan.style.width = '100%';
    this.titleSpan.style.zIndex = '99';
    this.titleSpan.style.display = 'flex';
    this.titleSpan.style.height = '50px';
    this.titleSpan.style.alignItems = 'center';
    this.titleSpan.style.justifyContent = 'center';
    this.titleSpan.style.background = 'rgb(12 0 0 / 10%)';
    this.titleSpan.style.userSelect = 'none';
  this.titleSpan.textContent = this.titles;
  // this.titleSpan.style.display = this.isPlaying ? 'none' : 'block'; 
  // this.titleSpan.style.display = '{ isPlaying ? "none" : "block"}'

  this.titleBarContainer.appendChild(this.titleSpan);
  this.playerElement.insertBefore(this.titleBarContainer, this.playerElement.firstChild);

  this.disableTitle();
}

  disableTitle() {
    setTimeout(() => {
      this.titleSpan.style.display = 'none';
    }, 5000);

  }

  removeTitleBar() {
    // Remove any existing title bars
    if (this.titleBarContainer && this.titleBarContainer.parentNode) {
      this.titleBarContainer.parentNode.removeChild(this.titleBarContainer);
    }
  }

backToInfo_(catId){
    // if(this.seriesIds){
    //   this.router.navigate([`series/info/${this.seriesIds}`])
    // }
    console.log(catId,this.seriesFrom,'-------');
    
    if(this.seriesFrom == 'search'){
      this.router.navigate([`/series/info/${catId}`],{queryParams:{seriesBy:'search'}})
    }else if(this.seriesFrom == 'home'){
      this.router.navigate([`/series/info/${catId}`],{queryParams:{seriesBy:'home'}})
    }else if(this.seriesFrom == 'series'){
      this.router.navigate([`/series/info/${catId}`],{queryParams:{seriesBy:'series'}})
    }else if(this.seriesFrom == 'favourites'){
      this.router.navigate([`/series/info/${catId}`],{queryParams:{seriesBy:'favourites'}})
    } else{
      this.router.navigate(['/series'])
    }
  }

  backToInfo() {

    this.location.back();
    // const previousPage = localStorage.getItem('previousPage');
    // if (previousPage) {
    //   localStorage.removeItem('previousPage');
    //   window.location.href = previousPage;
    // } else {
    //  this.router.navigate(['/series'])
    // }
  }
  // addKeyPressEvent() {
    
  //   this.elRef.nativeElement.addEventListener('keypress', (event) => {
  //     if (event.keyCode === 32) {
  //       this.togglePlayPause();  
  //     }
  //   });
  // }
  // togglePlayPause(){
  //   if(this.player.paused()){
  //     this.player.play()
  //   }else{
  //     this.player.paused()
  //   }
  // }

  ngOnDestroy(): void {
    this.player = videojs('series-player');
    this.player.dispose()
    // this.player.removeChild('BigPlayButton')
    if (document.pictureInPictureEnabled && document.exitPictureInPicture) {
      document.exitPictureInPicture();
    } else {
      console.log('Picture-in-Picture mode or exitPictureInPicture() not supported.');
    }


  }





}
